export default __webpack_public_path__ + "static/media/hall-of-fame-icon-soundcloud.f3a944d2.svg";